<template>
    <div class="numpad-layour">
      <KeyButton class="numpad" v-for="({normalKey, shiftKey}) in keys"
        :key="normalKey"
        :normalKey="normalKey"
        :shiftKey="shiftKey"
        :shiftEnabled="shiftEnabled"
        @click="clickHandle">
      </KeyButton>
    </div>
</template>
<script>
    import KeyButton from './key-button.vue'
    export default {
      data () {
        return {
          shiftEnabled: false,
          value: '',
          keys: [
            {normalKey: 1, shiftKey: 1},
            {normalKey: 2, shiftKey: 2},
            {normalKey: 3, shiftKey: 3},
            {normalKey: 4, shiftKey: 4},
            {normalKey: 5, shiftKey: 5},
            {normalKey: 6, shiftKey: 6},
            {normalKey: 7, shiftKey: 7},
            {normalKey: 8, shiftKey: 8},
            {normalKey: 9, shiftKey: 9},
            {normalKey: 'CE', shiftKey: 'CE'},
            {normalKey: 0, shiftKey: 0},
            {normalKey: '←', shiftKey: '←'}
          ]
        }
      },
      props: ['val'],
      computed: {
      },
      created: function () {
        this.value = this.val
      },
      methods: {
        clickHandle (val) {
          if (val === '←' && this.value.length) {
            this.value = this.value.split('').splice(0, this.value.length - 1).join('')
          } else if (val === '←') {
            return
          } else if (val === 'CE') {
            this.value = ''
          } else {
            this.value += val
          }
          if (+this.value >= 5000) {
            this.value = '5000'
          }

          this.$emit('change', this.value)
        }
      },
      components: {
        KeyButton
      }
    }
</script>
<style scoped>
  .numpad-layour {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    height: 100%;
    width: 80%;
    margin: 0 auto;
  }
  @media screen and (min-width: 1200px) and (min-height: 904px) {
    .numpad-layour {
      height: 90%;
      width: 85%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/numpad.vue